import { ActionTypes } from '../constans/action-types';

export const setCurrentRecording = payload => ({
  type: ActionTypes.SET_CURRENT_RECORDING,
  payload,
});

export const resetRecording = () => ({
  type: ActionTypes.RESET_RECORDING,
});
